import React,{useState,useEffect} from 'react';
import axios from "axios";
import {Row,Col,Card,Button,Form,Spin,Modal,Divider,Upload,message,Layout,Popconfirm, Alert} from "antd";
import { DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined,CloudUploadOutlined,UploadOutlined,ReadOutlined } from "@ant-design/icons";
import { useSelector,useDispatch } from "react-redux";
import SiderBar from './SiderBar';
import { getKycs } from '../../features/KycSlice';

const { Content} = Layout;

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

const KycDetails = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [Loading, setLoading] = useState(false);
  const { user: currentUser } = useSelector((state) => state.auth);
  const kycs = useSelector((state) => state.kyc);
  const formRef = React.createRef();
  console.log(kycs.list);
  console.log(currentUser);
  const id = currentUser.Id;
  const clientAPIkey = currentUser.ClientApikey;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getKycs({ id: id }))
  }, [dispatch]);


  const onReset = () => {
   formRef.current.resetFields();
 };
 
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };


const deleteFile = (clientId,Docname,clientAPIkey)=>{
if(clientId!==undefined){
      let headersList = {
        "accept": "*/*",
        "Content-Type": "application/json;",
        'Authorization': clientAPIkey,
        }
        let reqOptions = {
          url: `${process.env.REACT_APP_BASE_URL}client/remove-file/`+clientId+"/"+Docname,
          method: "DELETE",
          headers: headersList,
            }
            axios.request(reqOptions).then(function (response) {
              dispatch(getKycs({ id: id }));
              message.success("Your document has been DELETED successfully");
            }).catch((error) => {
          if (error.response?.status === 404) {
            message.error(error.response.data)
          }
          else if(error.response?.status === 400){
            message.error(error.response.data)
          }
          else if(error.response?.status === 500){
            message.error(error.response.data)
          }
          else if(error.response?.status === 401){
            message.error(error.response.data)
                }
       })        
    }
}
const onFinish = (values)=>{
    setIsModalVisible(false);
    setLoading(true);
    var data = new FormData();
    data.append("document", values.file[0].originFileObj);
    let sendData = data; 

if(clientAPIkey!==undefined){
    let headersList = {
      "accept": "*/*",
      "Content-Type": "multipart/form-data" ,
      'Authorization': clientAPIkey ,
      }
      let reqOptions = {
        url: `${process.env.REACT_APP_BASE_URL}Client/docs/kycs`,
        method: "POST",
        headers: headersList,
        data: data,
          }
          axios.request(reqOptions).then(function (response) { 
            setLoading(false);
            onReset();
            dispatch(getKycs({ id: id }));
            message.success("successfully submitted your document");
          }).catch((error) => {
        if (error.response?.status === 404) {
          onReset();
          setLoading(false);
          message.error(error.response.data)
        }
        else if(error.response?.status === 400){
          onReset();
          setLoading(false);
          message.error(error.response.data)
        }
        else if(error.response?.status === 500){
          onReset();
          setLoading(false);
          message.error(error.response.data)
        }
        else if(error.response?.status === 401){
          onReset();
            setLoading(false);
            message.error(error.response.data)
              }
      })  
  }

}
return (  
  <Content style={{marginTop:'5%'}}>  
  <Layout hasSider >
   <SiderBar props='2' />
  <Layout className="site-layout">
    <Content style={{ margin: '10px 0px 0', overflow: 'initial' }}> 
  <Row gutter={[24, 0]}>
    <Col xs={24} sm={24} md={12} lg={12} xl={24} className="mb-24">
      <Card
        bordered={false}
        className="criclebox cardbody h-full">
      <div className="project-ant">
        <div className="ant-filtertabs">
          <div className="antd-pro-pages-dashboard-analysis-style-salesExtra">
           {Loading?<Button disabled><CloudUploadOutlined />Upload new file</Button>:
                    <Button onClick={showModal}><CloudUploadOutlined /> Upload new file</Button>} 
          </div>
        </div>
      </div>
      <div className="ant-list-box table-responsive">
         <Divider/>
        <table className="width-100">
          <thead>
            <tr>
              <th>Document Name</th>
              <th>Description</th>
              <th>View</th>
              <th>Approved</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            { kycs.status==='loading'||Loading?<Spin size='large'  tip="Loading..." style={{margin:'30% 100%'}}/>:
            kycs.list?.map((information) => (
              <tr key={information.Filename}>
                <td>
                  <h6>
                    {information.Filename}
                  </h6>
                </td>
                <td>
                  <h6>{information.Description}</h6></td>
                <td>
                <h6><a href={`${process.env.REACT_APP_BASE_URL}client/view-file?id=${id}&filesrc=${information.Filename}`} target='_blank'><ReadOutlined /></a></h6>
                </td>
                <td>
                <h6>{information.Verified===1?<CheckCircleOutlined size={50}/>:<CloseCircleOutlined size={50} />}</h6>
                </td>
                  <td>
                    <Popconfirm
                          title=" Delete this?"
                          onConfirm={()=>deleteFile(id,information.Filename,clientAPIkey)}
                          okText="Yes"
                          cancelText="No">
                        <DeleteOutlined/>
                    </Popconfirm>
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </Card>
    </Col>
  </Row> 
    </Content>
  </Layout>
</Layout>
 
 <Modal title="Upload KYC file" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={null}>
   <Form onFinish={onFinish} ref={formRef}>
   <Form.Item
        name="file"
        label="Upload File"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={[
          {
            required: true,
            message: <Alert style={{marginTop:"1%"}} message="Please upload a file before submitting" type="error" showIcon/>,
          },
        ]}
        extra="you can upload file as PDF,DOCX,or Image">
        <Upload name="logo" action="/upload.do" listType="picture">
          <Button icon={<UploadOutlined />}>Click to upload</Button>
        </Upload>
    </Form.Item>
     <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
     </Form.Item>
   </Form>
  </Modal>  
</Content>    
  )
}

export default KycDetails